import { ClassTimestampsHelper } from '../ClassHelper';
import Account from '../account/Account';
import Point from '../point/Point';
import User from '../user/User';
import DateFormat from '../../components/DateFormat';
import DateTZ from '../date/DateTZ';

class EmployeeSchedule extends ClassTimestampsHelper {
  constructor({ account, user, point, date, timeFrom = 0, timeTo = 0 } = {}) {
    super(...arguments);
    this.account = this.ref(account, Account);
    this.user = this.obj(user, User);
    this.point = this.ref(point, Point);
    this.date = this.obj(date, DateTZ);
    this.timeFrom = timeFrom;
    this.timeTo = timeTo;
  }

  getDate() {
    return DateFormat({ date: this.date });
  }

  getTimeFrom() {
    return `${(~~(this.timeFrom / 100)).toString().padStart(2, '0')}:${(this.timeFrom % 100).toString().padStart(2, '0')}`;
  }

  getTimeTo() {
    return `${(~~(this.timeTo / 100)).toString().padStart(2, '0')}:${(this.timeTo % 100).toString().padStart(2, '0')}`;
  }

  isNow() {
    let now = new DateTZ().getDayjs();
    // let from = this.date && this.timeFrom ? new DateTZ(`${this.date.getDayString('YYYY-MM-DD')}T${this.getTimeFrom()}:00.000`).getDayjs() : null;
    // let to = this.date && this.timeTo ? new DateTZ(`${this.date.getDayString('YYYY-MM-DD')}T${this.getTimeTo()}:00.000`).getDayjs() : null;
    let from = this.date && this.timeFrom ? this.date.getDayjs().startOf('day') : null;
    let to = this.date && this.timeTo ? this.date.getDayjs().endOf('day') : null;

    return (!to || to.isAfter(now)) && (!from || from.isBefore(now));
  }

  getSchedule() {
    return {
      date: this.date.getDayjs(),
      from: this.timeFrom,
      to: this.timeTo
    };
  }
}

export default EmployeeSchedule;